import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function GeceUyanmaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['gece-uyanma-testi']} />;
}
